import styled from 'styled-components'

import { helpers } from 'styles'

export const Subtitle = styled.span`
	padding: 12px 4px 8px 16px;
	color: ${helpers.color.textMuted};
`
